import { Message } from 'element-ui'
import {
  getCapitalLetters,
  getDistinct,
  getSameAttribute,
  getSurplusKeys,
  removeNull,
  sortArray
} from '@/utils/handleData'
import { publicPickScope } from '@/utils/tabPages'
import {
  isQuestionOnPaper,
  paperAddedKeys
} from '@/utils/paperCompose.js'

export default {
  namespaced: true,
  state: {
    papersList: {}, // 试卷列表
    paperInfo: {}, // 试卷信息
    questionList: {}, // 题库列表
    questionInfo: {} // 题目信息
  },
  getters: {
    questionList: (state, gettets, rootState) => {
      var questionList = state.paperInfo.questionList
        ? state.paperInfo.questionList
        : []
      const stepLabel =
        rootState.currentStep && typeof rootState.currentStep.label === 'string'
          ? rootState.currentStep.label
          : ''
      const answers =
        stepLabel.slice(-4) === '答卷详情' &&
        rootState.signIn &&
        rootState.signIn.answers &&
        rootState.signIn.answers[0] &&
        rootState.signIn.answers[0].paperUid === state.paperInfo.uid
          ? rootState.signIn.answers
          : []
      questionList = questionList.map((item) => {
        const answer = answers.find((a) => a.questionUid === item.uid)
        if (answer) {
          item.answer = answer.answer
          item.answerScore = answer.score
          item.isTrue = answer.isTrue
          item.detailForm[item.detailForm.length - 2].value = item.answer
          item.detailForm[item.detailForm.length - 2].isShow = true
          item.detailForm[item.detailForm.length - 2].error = item.isTrue === 0
        }
        return item
      })
      questionList =
        !rootState.radio || rootState.radio === '全部'
          ? questionList
          : questionList.filter((item) => {
              return item.questionType === rootState.radio
            })
      return questionList
    }
  },
  actions: {
    // 获取试卷列表
    async getPapersList({ rootState, rootGetters, commit, dispatch }, data) {
      const theme =
        (rootState.currentStep && rootState.currentStep.theme) || ''
      const qvKey =
        theme === 'paperLibrary'
          ? 'paperLibrary'
          : theme === 'publicPapers'
          ? 'publicPapers'
          : 'paper'
      const qv = rootState.queryValues[qvKey] || {}
      let defaultScope = 'orgOwned'
      if (theme === 'paperLibrary') defaultScope = 'all'
      else if (theme === 'publicPapers') defaultScope = 'public'
      else if (
        rootState.drawerTableVisible &&
        rootState.drawerName === 'paper' &&
        theme === 'training'
      ) {
        defaultScope = publicPickScope(
          rootGetters['user/pages'],
          'onlineExam',
          '公共试卷库',
          rootState.user.userName,
          rootState.superAdminName
        )
      }
      let listOrgUid = data && data.orgUid ? data.orgUid : qv.orgUid
      if (theme === 'publicPapers' && !listOrgUid) {
        listOrgUid = (rootState.user && rootState.user.orgValue) || ''
      }
      var queryValues = {
        orgUid: listOrgUid,
        scope:
          theme === 'publicPapers'
            ? 'public'
            : data && data.scope
            ? data.scope
            : qv.scope || defaultScope,
        paperType: data
          ? data.paperType
          : (qv.paperType || []).join
          ? (qv.paperType || []).join()
          : qv.paperType,
        applicableUsers: data
          ? data.applicableUsers
          : (qv.applicableUsers || []).join
          ? (qv.applicableUsers || []).join()
          : qv.applicableUsers,
        paperStatus: data ? data.paperStatus : qv.paperStatus,
        paperDifficulty: data
          ? data.paperDifficulty
          : qv.paperDifficulty,
        query: data ? data.query : qv.query,
        page:
          data && data.page
            ? data.page
            : rootState.page[qvKey]
            ? rootState.page[qvKey]
            : 1,
        limit:
          data && data.limit
            ? data.limit
            : rootState.limit[qvKey]
            ? rootState.limit[qvKey]
            : 10
      }
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/cultivate/gpaperlist',
          data: queryValues
        },
        { root: true }
      )
      // console.log(res)
      var papersList = res.data ? res.data : {}
      if (!Array.isArray(papersList.result)) {
        papersList.result = []
      }
      papersList.result.forEach((item) => {
        item.paperType = item.paperType ? item.paperType.join('、') : ''
        item.examinationLabels =
          '【' +
          item.paperType +
          (item.examinationLabels ? '、' + item.examinationLabels : '') +
          '】'
        item.applicableUsers = '【' + item.applicableUsers.join('、') + '】'
        item.questionTypesIncluded = item.questionTypesIncluded
          ? item.questionTypesIncluded
          : []
        item.questionTypes = item.questionTypesIncluded
          ? '【' + item.questionTypesIncluded.join('、') + '】'
          : ''
        item.questionNum = item.questionNum ? item.questionNum : 0
        item.score = item.score ? item.score : 0
        item.questionInfo =
          '共计' +
          item.questionNum +
          '道试题，包含' +
          item.questionTypes +
          item.questionTypesIncluded.length +
          '种题型，合计' +
          item.score +
          '分'
        item.paperTimeLimit = item.paperTimeLimit + '分钟'
        item.passingScore = item.passingScore + '%'
        item.disabledButtons = []
        if (item.score === 0) {
          item.paperStatus = '新建'
          item.disabledButtons.push(2)
        } else if (item.score && item.score !== item.paperTotalScore) {
          item.paperStatus = '编辑中'
          item.disabledButtons.push(2)
        } else if (
          item.score &&
          item.score === item.paperTotalScore &&
          item.paperStatus !== '3'
        ) {
          item.paperStatus = '待确认'
        } else if (item.paperStatus === '3') {
          item.paperStatus = '已确认'
          const isSuperAdmin =
            rootState.user.userName === rootState.superAdminName ||
            rootState.user.personName === rootState.superAdminName
          // 超管可删除已确认试卷；编辑/确认仍禁用
          if (isSuperAdmin) {
            item.disabledButtons.push(0, 2)
          } else {
            item.disabledButtons.push(0, 1, 2)
          }
        }
        if (
          (!item.orgUid ||
            (item.orgUid && item.orgUid !== rootState.user.orgValue)) &&
          rootState.user.userName !== 'dpnadmin'
        ) {
          item.disabledButtons.push(0, 1, 2)
        }
        item.detailForm = [
          {
            prop: 'paperTitle',
            label: '试卷主题',
            value: item.paperTitle,
            span: rootState.drawerTableVisible ? 24 : 12
          },
          {
            prop: 'applicableUsers',
            label: '适用对象',
            value: item.applicableUsers,
            span: rootState.drawerTableVisible ? 24 : 12
          },
          {
            prop: 'examinationLabels',
            label: '试卷类型及考点标签',
            value: item.examinationLabels,
            fontBold: true,
            span: rootState.drawerTableVisible ? 24 : 12
          },
          {
            prop: 'questionInfo',
            label: '试题信息',
            value: item.questionNum ? item.questionInfo : '点击查看详情',
            drillDown: true,
            span: rootState.drawerTableVisible ? 24 : 12
          },
          {
            prop: 'paperDescription',
            label: '试卷简述',
            value: item.paperDescription,
            span: 24
          }
        ]
      })
      if (!data && (qv.questionType || []).length) {
        papersList.result = papersList.result.filter((item) => {
          return !getSurplusKeys(
            qv.questionType,
            item.questionTypesIncluded
          ).length
        })
      }
      commit(
        'baseSet',
        { module: 'onlineExam', key: 'papersList', value: papersList },
        { root: true }
      )
    },
    // 新增试卷
    async addPaper({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/cultivate/gpaper',
          data: data,
          msg: '新增试卷成功'
        },
        { root: true }
      )
      return res
    },
    // 获取试卷详情
    async getPaperInfo({ state, rootState, commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/cultivate/gpaper',
          data: { uid: uid ? uid : state.paperInfo.uid }
        },
        { root: true }
      )
      //console.log(res)
      var paperInfo = res.data ? res.data : {}
      const questionType = getSameAttribute(
        rootState.dictionarys.questionType,
        'label'
      ).values
      paperInfo.questionList = paperInfo.questionList
        ? sortArray(
            paperInfo.questionList,
            ['questionType', 'score'],
            [questionType]
          )
        : []
      paperInfo.questionNum = paperInfo.questionList.length
      paperInfo.questionTypesIncluded = getDistinct(
        getSameAttribute(paperInfo.questionList, 'questionType').values
      )
      paperInfo.questionList.forEach((item, index) => {
        item.paperUid = paperInfo.uid
        item.disabledButtons = []
        if (paperInfo.paperStatus === '3') {
          item.disabledButtons.push(0, 1)
        }
        if (
          (!paperInfo.orgUid ||
            (paperInfo.orgUid &&
              paperInfo.orgUid !== rootState.user.orgValue)) &&
          rootState.user.userName !== 'dpnadmin'
        ) {
          item.disabledButtons.push(0, 1)
        }
        item.questionCode = index + 1 + '.'
        item.optionsForm = {}
        item.option = []
        const options = []
        const codes = getCapitalLetters()
        if (item.options) {
          if (
            item.questionType === '单选题' ||
            item.questionType === '多选题'
          ) {
            item.options.forEach((option) => {
              option = option.split('@|@')
              option.forEach((child, num) => {
                const code = 'option' + codes[num]
                options.push({
                  prop: code,
                  label: '选项' + codes[num],
                  value: child,
                  span: num % 2 === 0 && num === option.length - 1 ? 24 : 12
                })
                item.optionsForm[code] = child
                option[num] = '选项' + codes[num] + '：' + child
              })
              item.option.push(option.join('；\n'))
            })
            item.option = item.option.join('；\n')
          }
        }
        item.answers = []
        ;(item.correctAnswer || []).forEach((answer) => {
          answer = answer.split('@|@')
          if (
            item.questionType === '单选题' ||
            item.questionType === '多选题'
          ) {
            answer.forEach((child, num) => {
              const ans = options.find((option) => {
                return option.value === child
              })
              answer[num] = ans && ans.prop.slice(-1)
            })
            item.answers.push(answer.join(''))
            item.optionsForm.answer = answer.map((a) => {
              return 'option' + a
            })
            item.answers = item.answers.join('；\xa0\xa0')
          } else {
            item.answers.push(answer.join('；'))
            item.answers = item.answers.join('；\n\t')
          }
        })
        const img = /<img[^>]*src=["']([^"']+)["'][^>]*>/g
        const table = /<table.*?>[\s\S]*?<\/table>/gi
        item.questionContent = item.questionContent ? item.questionContent : ''
        item.contentTables = item.questionContent.match(table)
          ? item.questionContent.match(table).join('')
          : ''
        item.contentImgMatch = item.questionContent
          .replace(table, '')
          .match(img)
        item.contentImgs = item.contentImgMatch
          ? item.contentImgMatch.join('')
          : ''
        let contentImgMatch
        item.contentImgUrls = []
        while ((contentImgMatch = img.exec(item.contentImgs)) !== null) {
          item.contentImgUrls.push(contentImgMatch[1])
        }
        item.imgTables =
          item.contentImgs || item.contentTables
            ? [
                {
                  prop: 'imgTables',
                  label: '题目图表',
                  htmlContent: item.contentImgs + item.contentTables,
                  span: 24
                }
              ]
            : []
        item.content = item.questionContent.replace(table, '').replace(img, '')
        item.questionAnalysis = item.questionAnalysis
          ? item.questionAnalysis
          : ''
        item.analysisTables = item.questionAnalysis.match(table)
          ? item.questionAnalysis.match(table).join('')
          : ''
        item.analysisImgMatch = item.questionAnalysis
          .replace(table, '')
          .match(img)
        item.analysisImgs = item.analysisImgMatch
          ? item.analysisImgMatch.join('')
          : ''
        let analysisImgMatch
        item.analysisImgUrls = []
        while ((analysisImgMatch = img.exec(item.analysisImgs)) !== null) {
          item.analysisImgUrls.push(analysisImgMatch[1])
        }
        item.analysis = item.questionAnalysis
          .replace(table, '')
          .replace(img, '')
        item.questionScore = '（' + item.score + '分）'
        item.detailForm = item.imgTables.concat(options, [
          {
            prop: 'answers',
            label: '参考答案',
            value: item.answers,
            fontBold: true,
            span: 24
          },
          {
            prop: 'answer',
            label: '考生答案',
            isShow: item.answer !== undefined,
            value: item.answer,
            fontBold: true,
            span: 24
          },
          {
            prop: 'analysis',
            label: '题目解析',
            value: item.analysis,
            htmlContent: item.analysisImgs + item.analysisTables,
            span: 24
          }
        ])
      })
      paperInfo.questionTypes = paperInfo.questionTypesIncluded
        ? '【' + paperInfo.questionTypesIncluded.join('、') + '】'
        : ''
      paperInfo.totalScore = getSameAttribute(
        paperInfo.questionList,
        'score'
      ).addValue
      paperInfo.questionInfo =
        '共计' +
        paperInfo.questionList.length +
        '道试题，包含' +
        paperInfo.questionTypes +
        (paperInfo.questionTypesIncluded
          ? paperInfo.questionTypesIncluded.length
          : 0) +
        '种题型，合计' +
        paperInfo.totalScore +
        '分'
      commit(
        'baseSet',
        { module: 'onlineExam', key: 'paperInfo', value: paperInfo },
        { root: true }
      )
      return paperInfo
    },
    // 编辑试卷
    async editPaper({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/cultivate/gpaper',
          data: data,
          msg: '编辑试卷成功'
        },
        { root: true }
      )
      return res
    },
    // 确认试卷
    async confirmPaper({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/cultivate/gpaperStatus',
          data: { uid: data.uid },
          msg: '确认试卷成功'
        },
        { root: true }
      )
      return res
    },
    // 删除试卷
    async deletePaper({ rootState, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/cultivate/gpaper',
          data: {
            uid: uid,
            orgUid:
              rootState.user.userName === 'dpnadmin'
                ? ''
                : rootState.user.orgValue
          },
          msg: '删除试卷成功'
        },
        { root: true }
      )
      return res
    },
    // 新增试卷题目
    async addPaperQuestion({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/cultivate/paperquestion',
          data: data,
          msg: '新增试卷题目成功'
        },
        { root: true }
      )
      return res
    },
    // 系统生成试卷题目
    async createPaperQuestion({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/cultivate/createpaperquestion',
          data: data,
          msg: true
        },
        { root: true }
      )
      return res
    },
    // 编辑试卷题目
    async editPaperQuestion({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/cultivate/paperquestion',
          data: data,
          msg: '编辑试卷题目成功'
        },
        { root: true }
      )
      return res
    },
    // 删除试卷题目
    async deletePaperQuestion({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/cultivate/paperquestion',
          data: { uid: uid },
          msg: '删除试卷题目成功'
        },
        { root: true }
      )
      return res
    },
    // 提交试卷答案
    async postPaper({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/person/cultivate/answer',
          data: data,
          msg: '交卷成功'
        },
        { root: true }
      )
      return res
    },
    // 手动判分提交保存试卷答案
    async updatePaper({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/person/cultivate/updateanswer',
          data: data,
          msg: '手动判分更新或提交成功'
        },
        { root: true }
      )
      return res
    },
    // 获取题库列表
    async getQuestionList({ rootState, rootGetters, commit, dispatch }, data) {
      const theme =
        (rootState.currentStep && rootState.currentStep.theme) || ''
      const pageName =
        theme === 'questionLibrary'
          ? 'questionLibrary'
          : theme === 'publicQuestions'
          ? 'publicQuestions'
          : rootState.currentStep.step === 'questionList'
          ? 'question'
          : rootState.drawerTableVisible && rootState.drawerName === 'addQuestion'
          ? 'addQuestion'
          : 'question'
      const qv = rootState.queryValues[pageName] || {}
      const isSuperAdmin =
        rootState.user.userName === rootState.superAdminName ||
        rootState.user.personName === rootState.superAdminName
      let defaultScope = 'orgOwned'
      if (theme === 'questionLibrary') defaultScope = 'all'
      else if (theme === 'publicQuestions') defaultScope = 'public'
      else if (pageName === 'addQuestion') {
        const paper = (rootState.formValues && rootState.formValues.paper) || {}
        const access = paper.paperAccess || ''
        if (
          isSuperAdmin &&
          (access === '公开' || access === 'public' || !access)
        ) {
          defaultScope = 'public'
        } else {
          defaultScope = publicPickScope(
            rootGetters['user/pages'],
            'onlineExam',
            '公共试题库',
            rootState.user.userName,
            rootState.superAdminName
          )
        }
      }
      let listOrgUid = data && data.orgUid ? data.orgUid : qv.orgUid
      if (theme === 'publicQuestions' && !listOrgUid) {
        listOrgUid = (rootState.user && rootState.user.orgValue) || ''
      }
      var queryValues = {
        orgUid: listOrgUid,
        scope:
          theme === 'publicQuestions'
            ? 'public'
            : data && data.scope
            ? data.scope
            : qv.scope || defaultScope,
        knowledgeType: (() => {
          const kt = data ? data.knowledgeType : qv.knowledgeType
          return Array.isArray(kt) ? kt.join() : kt
        })(),
        applicableUsers: (() => {
          const au = data ? data.applicableUsers : qv.applicableUsers
          return Array.isArray(au) ? au.join() : au
        })(),
        questionType: data ? data.questionType : qv.questionType,
        questionDifficulty: data
          ? data.questionDifficulty
          : qv.questionDifficulty,
        query: data ? data.query : qv.query,
        reviewStatus:
          pageName === 'addQuestion'
            ? 'ready'
            : data && data.reviewStatus
            ? data.reviewStatus
            : qv.reviewStatus || '',
        page:
          data && data.page
            ? data.page
            : rootState.page[pageName]
            ? rootState.page[pageName]
            : 1,
        limit:
          data && data.limit
            ? data.limit
            : rootState.limit[pageName]
            ? rootState.limit[pageName]
            : 10
      }
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/cultivate/gquestionbanklist',
          data: queryValues
        },
        { root: true }
      )
      // console.log(res)
      var questionList = res.data ? res.data : {}
      if (!Array.isArray(questionList.result)) {
        questionList.result = []
      }
      const addedKeys =
        pageName === 'addQuestion'
          ? paperAddedKeys(rootState.onlineExam && rootState.onlineExam.paperInfo)
          : null
      questionList.result.forEach((item) => {
        item.disabledButtons = []
        if (addedKeys) {
          item.paperAdded = isQuestionOnPaper(item, addedKeys)
          item.paperAddedText = item.paperAdded ? '已添加' : ''
          item.unselectable = !!item.paperAdded
        }
        const reviewStatus =
          item.reviewStatus && String(item.reviewStatus).trim()
            ? String(item.reviewStatus).trim()
            : '已审核'
        item.reviewStatus = reviewStatus
        item.reviewStatusText = reviewStatus
        if (
          (!item.orgUid ||
            (item.orgUid && item.orgUid !== rootState.user.orgValue)) &&
          rootState.user.userName !== 'dpnadmin'
        ) {
          item.disabledButtons.push(0, 1)
        }
        item.knowledgeTypes = Array.isArray(item.knowledgeType)
          ? item.knowledgeType.join('、')
          : item.knowledgeType || ''
        item.knowledgeLabels =
          '【' +
          item.knowledgeTypes +
          (item.knowledgeLabels ? '、' + item.knowledgeLabels : '') +
          '】'
        const applicableArr = Array.isArray(item.applicableUsers)
          ? item.applicableUsers
          : item.applicableUsers
          ? [item.applicableUsers]
          : []
        item.applicableUsersText = applicableArr.join('、')
        item.applicableUsers = '【' + applicableArr.join('、') + '】'
        const options = []
        const codes = getCapitalLetters()
        if (item.options) {
          if (
            item.questionType === '单选题' ||
            item.questionType === '多选题'
          ) {
            item.options.forEach((option, index) => {
              item.options[index] = option.split('@|@')
              item.options[index].forEach((child, num) => {
                const code = 'option' + codes[num]
                options.push({
                  prop: code,
                  label: '选项' + codes[num],
                  value: child,
                  span:
                    num % 2 === 0 && num === item.options[index].length - 1
                      ? 24
                      : 12
                })
              })
            })
          }
        }
        item.correctAnswer.forEach((answer, index) => {
          item.correctAnswer[index] = answer.split('@|@')
          if (
            item.questionType === '单选题' ||
            item.questionType === '多选题'
          ) {
            item.correctAnswer[index].forEach((child, num) => {
              const ans = options.find((option) => {
                return option.value === child
              })
              item.correctAnswer[index][num] = ans && ans.prop.slice(-1)
            })
            item.correctAnswer[index] = item.correctAnswer[index].join('')
            item.answers = item.correctAnswer.join('；\xa0\xa0')
          } else {
            item.correctAnswer[index] = item.correctAnswer[index].join('；')
            item.answers = item.correctAnswer.join('；\n\t')
          }
        })
        item.useInfo = item.errorNum + '/' + item.submitNum
        item.questionScore = '（' + item.score + '分）'
        const img = /<img[^>]*src=["']([^"']+)["'][^>]*>/g
        const table = /<table.*?>[\s\S]*?<\/table>/gi
        item.questionContent = item.questionContent ? item.questionContent : ''
        item.contentTables = item.questionContent.match(table)
          ? item.questionContent.match(table).join('')
          : ''
        item.contentImgs = item.questionContent.replace(table, '').match(img)
          ? item.questionContent.replace(table, '').match(img).join('')
          : ''
        item.imgTables =
          item.contentImgs || item.contentTables
            ? [
                {
                  prop: 'imgTables',
                  label: '题目图表',
                  htmlContent: item.contentImgs + item.contentTables,
                  span: 24
                }
              ]
            : []
        item.content = item.questionContent.replace(table, '').replace(img, '')
        item.questionAnalysis = item.questionAnalysis
          ? item.questionAnalysis
          : ''
        item.analysisImgs = item.questionAnalysis.replace(table, '').match(img)
          ? item.questionAnalysis.replace(table, '').match(img).join('')
          : ''
        item.analysisTables = item.questionAnalysis.match(table)
          ? item.questionAnalysis.match(table).join('')
          : ''
        item.analysis = item.questionAnalysis
          .replace(table, '')
          .replace(img, '')
        item.detailForm = item.imgTables.concat(options, [
          {
            label: '题目权限',
            prop: 'questionAccess',
            value: item.questionAccess,
            span: 12
          },
          {
            label: '题目难度',
            prop: 'questionDifficulty',
            value: item.questionDifficulty,
            span: 12
          },
          {
            label: '答错/答题',
            prop: 'useInfo',
            value: item.useInfo,
            fontBold: true,
            span: 12
          },
          {
            prop: 'applicableUsers',
            label: '适用对象',
            value: item.applicableUsers,
            span: 12
          },
          {
            prop: 'knowledgeLabels',
            label: '知识点类型及标签',
            value: item.knowledgeLabels,
            span: 24
          },
          {
            prop: 'answers',
            label: '参考答案',
            value: item.answers,
            fontBold: true,
            span: 24
          },
          {
            prop: 'analysis',
            label: '题目解析',
            value: item.analysis,
            htmlContent: item.analysisImgs + item.analysisTables,
            span: 24
          }
        ])
      })
      commit(
        'baseSet',
        { module: 'onlineExam', key: 'questionList', value: questionList },
        { root: true }
      )
    },
    // 新增题目
    async addQuestion({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/cultivate/gquestionbank',
          data: data,
          msg: '新增题目成功'
        },
        { root: true }
      )
      return res
    },
    // 导入预览：AI 识别重置
    async aiParseQuestions({ dispatch }, items) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/cultivate/gquestionbankaiparse',
          data: { items },
          msg: true
        },
        { root: true }
      )
      return res
    },
    // 批量更新知识点类型 / 适用对象（弹窗提交时从列表勾选读取 uid；原地刷新行，不重拉列表以免分页跳动）
    async batchUpdateQuestionTags({ rootState, getters, commit, dispatch }, data) {
      let uids = Array.isArray(data && data.uids)
        ? data.uids
        : Array.isArray(data)
        ? data
        : []
      const pageName =
        (getters.check && getters.check.name) ||
        (rootState.currentStep &&
        String(rootState.currentStep.step || '').indexOf('questionLibrary') === 0
          ? 'questionLibrary'
          : 'question')
      if (!uids.length) {
        const selected =
          (rootState.selection && rootState.selection[pageName]) || []
        uids = selected.map((item) => item && item.uid).filter(Boolean)
      }
      const knowledgeType = (data && data.knowledgeType) || []
      const applicableUsers = (data && data.applicableUsers) || []
      if (!uids.length) {
        Message({ message: '请先勾选要加标签的题目', type: 'warning' })
        return { code: 400 }
      }
      if (!knowledgeType.length && !applicableUsers.length) {
        Message({ message: '请至少选择一类标签', type: 'warning' })
        return { code: 400 }
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/cultivate/gquestionbanktags',
          data: {
            uids: uids,
            knowledgeType: knowledgeType,
            applicableUsers: applicableUsers,
            orgUid: resolveQuestionOrgUid(rootState)
          },
          msg: '标签更新成功'
        },
        { root: true }
      )
      if (!res || res.code !== 200) return res
      const uidSet = {}
      uids.forEach((uid) => {
        uidSet[uid] = true
      })
      const list = rootState.onlineExam.questionList || {}
      const rows = Array.isArray(list.result) ? list.result : []
      const nextRows = rows.map((item) => {
        if (!item || !uidSet[item.uid]) return item
        const next = Object.assign({}, item)
        if (knowledgeType.length) {
          next.knowledgeType = [].concat(knowledgeType)
          next.knowledgeTypes = knowledgeType.join('、')
          next.knowledgeLabels = '【' + next.knowledgeTypes + '】'
        }
        if (applicableUsers.length) {
          next.applicableUsers = '【' + applicableUsers.join('、') + '】'
          next.applicableUsersText = applicableUsers.join('、')
        }
        if (Array.isArray(next.detailForm)) {
          next.detailForm = next.detailForm.map((field) => {
            if (!field) return field
            if (field.prop === 'knowledgeLabels' && knowledgeType.length) {
              return Object.assign({}, field, { value: next.knowledgeLabels })
            }
            if (field.prop === 'applicableUsers' && applicableUsers.length) {
              return Object.assign({}, field, { value: next.applicableUsers })
            }
            return field
          })
        }
        return next
      })
      commit(
        'baseSet',
        {
          module: 'onlineExam',
          key: 'questionList',
          value: Object.assign({}, list, { result: nextRows })
        },
        { root: true }
      )
      const selected =
        (rootState.selection && rootState.selection[pageName]) || []
      if (selected.length) {
        commit(
          'selectionSet',
          {
            key: pageName,
            value: selected.map((row) => {
              if (!row || !uidSet[row.uid]) return row
              return nextRows.find((r) => r && r.uid === row.uid) || row
            })
          },
          { root: true }
        )
      }
      return res
    },
    // 存疑题目审核通过（支持单条或批量 uids）
    async reviewQuestion({ rootState, dispatch }, data) {
      const uids = Array.isArray(data)
        ? data
        : data && Array.isArray(data.uids)
        ? data.uids
        : [data && (data.uid || data)]
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/cultivate/gquestionbankreview',
          data: {
            uids: uids.filter(Boolean),
            reviewStatus: '已审核',
            orgUid: resolveQuestionOrgUid(rootState)
          },
          msg: '审核通过'
        },
        { root: true }
      )
      return res
    },
    // 获取题目详情
    async getQuestionInfo({ commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/cultivate/gquestionbank',
          data: { uid: uid }
        },
        { root: true }
      )
      // console.log(res)
      var questionInfo = res.data ? res.data : {}
      questionInfo.answers = questionInfo.correctAnswer
      const options = []
      const codes = getCapitalLetters()

      if (
        questionInfo.options &&
        (questionInfo.questionType === '单选题' ||
          questionInfo.questionType === '多选题')
      ) {
        questionInfo.optionsForm = {}
        questionInfo.options.forEach((option) => {
          option = option.split('@|@')
          option.forEach((child, num) => {
            questionInfo.optionsForm['option' + codes[num]] = child
            option[num] = '选项' + codes[num] + '：' + child
          })
          options.push(option.join('；\n'))
        })
        questionInfo.option = options.join('；\n')
      }
      const answers = []
      if (questionInfo.correctAnswer) {
        questionInfo.correctAnswer.forEach((answer) => {
          answer = answer.split('@|@')
          if (
            questionInfo.questionType === '单选题' ||
            questionInfo.questionType === '多选题'
          ) {
            answer.forEach((child, num) => {
              for (const key in questionInfo.optionsForm) {
                if (Object.hasOwnProperty.call(questionInfo.optionsForm, key)) {
                  const item = questionInfo.optionsForm[key]
                  if (item === child) {
                    answer[num] = key.slice(-1)
                  }
                }
              }
            })
            answers.push(answer.join(''))
            questionInfo.optionsForm.answer = answer.map((a) => {
              return 'option' + a
            })
            questionInfo.answers = answers.join('；\xa0\xa0')
          } else {
            answers.push(answer.join('；'))
            questionInfo.answers = answers.join('；\n\t')
          }
        })
      }
      const img = /<img[^>]*src=["']([^"']+)["'][^>]*>/g
      const table = /<table.*?>[\s\S]*?<\/table>/gi
      questionInfo.questionContent = questionInfo.questionContent
        ? questionInfo.questionContent
        : ''
      questionInfo.contentTables = questionInfo.questionContent.match(table)
        ? questionInfo.questionContent.match(table).join('')
        : ''
      questionInfo.contentImgMatch = questionInfo.questionContent
        .replace(table, '')
        .match(img)
      questionInfo.contentImgs = questionInfo.contentImgMatch
        ? questionInfo.contentImgMatch.join('')
        : ''
      let contentImgMatch
      questionInfo.contentImgUrls = []
      while ((contentImgMatch = img.exec(questionInfo.contentImgs)) !== null) {
        questionInfo.contentImgUrls.push(contentImgMatch[1])
      }
      questionInfo.imgTables =
        questionInfo.contentImgs || questionInfo.contentTables
          ? [
              {
                prop: 'imgTables',
                label: '题目图表',
                htmlContent:
                  questionInfo.contentImgs + questionInfo.contentTables,
                span: 24
              }
            ]
          : []
      questionInfo.content = questionInfo.questionContent
        .replace(table, '')
        .replace(img, '')
      questionInfo.questionAnalysis = questionInfo.questionAnalysis
        ? questionInfo.questionAnalysis
        : ''
      questionInfo.analysisTables = questionInfo.questionAnalysis.match(table)
        ? questionInfo.questionAnalysis.match(table).join('')
        : ''
      questionInfo.analysisImgMatch = questionInfo.questionAnalysis
        .replace(table, '')
        .match(img)
      questionInfo.analysisImgs = questionInfo.analysisImgMatch
        ? questionInfo.analysisImgMatch.join('')
        : ''
      let analysisImgMatch
      questionInfo.analysisImgUrls = []
      while (
        (analysisImgMatch = img.exec(questionInfo.analysisImgs)) !== null
      ) {
        questionInfo.analysisImgUrls.push(analysisImgMatch[1])
      }
      questionInfo.analysis = questionInfo.questionAnalysis
        .replace(table, '')
        .replace(img, '')
      commit(
        'baseSet',
        { module: 'onlineExam', key: 'questionInfo', value: questionInfo },
        { root: true }
      )
      return questionInfo
    },
    // 编辑题目
    async editQuestion({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/cultivate/gquestionbank',
          data: data,
          msg: '编辑题目成功'
        },
        { root: true }
      )
      return res
    },
    // 删除题目
    async deleteQuestion({ rootState, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/cultivate/gquestionbank',
          data: {
            uid: uid,
            orgUid:
              rootState.user.userName === 'dpnadmin'
                ? uid
                : rootState.user.orgValue
          },
          msg: '删除题目成功'
        },
        { root: true }
      )
      return res
    },
    // 批量删除题目
    async batchDeleteQuestion({ rootState, dispatch }, data) {
      const uids = Array.isArray(data)
        ? data
        : data && Array.isArray(data.uids)
        ? data.uids
        : [data && (data.uid || data)]
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/cultivate/gquestionbankbatchdelete',
          data: {
            uids: uids.filter(Boolean),
            orgUid: resolveQuestionOrgUid(rootState)
          },
          msg: '批量删除成功'
        },
        { root: true }
      )
      return res
    },
    async resetQuestionDifficulty({ rootState, dispatch }, data) {
      const payload = {
        minSubmit: parseInt(
          data && data.minSubmit != null ? data.minSubmit : 20,
          10
        ),
        easyRate: parseFloat(data && data.easyRate != null ? data.easyRate : 80),
        hardRate: parseFloat(data && data.hardRate != null ? data.hardRate : 50),
        orgUid: resolveQuestionOrgUid(rootState)
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/cultivate/gquestionbankdifficulty',
          data: payload,
          msg: '重置题目难度成功'
        },
        { root: true }
      )
      return res
    }
  }
}

function isQuestionSuperAdmin(rootState) {
  return (
    rootState.user.userName === rootState.superAdminName ||
    rootState.user.personName === rootState.superAdminName
  )
}

/** 超管全库页不限机构；机构题库或非超管一律带本机构 orgUid */
function resolveQuestionOrgUid(rootState) {
  const theme =
    (rootState.currentStep && rootState.currentStep.theme) || ''
  if (isQuestionSuperAdmin(rootState) && theme === 'questionLibrary') {
    return ''
  }
  return rootState.user.orgValue || ''
}
